import React from 'react';
import { ConfirmDialogConfig } from '../../stores/ConfirmDialogStore';
import { Button } from './Button';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  config: ConfirmDialogConfig | null;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  config,
}) => {
  if (!isOpen || !config) return null;

  const {
    title,
    message,
    confirmText = 'Подтвердить',
    cancelText = 'Отмена',
    variant = 'info',
  } = config;

  const getVariantStyles = () => {
    switch (variant) {
      case 'danger':
        return {
          icon: '⚠️',
          confirmButtonClass: 'bg-red-600 hover:bg-red-700 text-white',
          borderClass: 'border-red-200',
        };
      case 'warning':
        return {
          icon: '⚠️',
          confirmButtonClass: 'bg-orange-600 hover:bg-orange-700 text-white',
          borderClass: 'border-orange-200',
        };
      default:
        return {
          icon: 'ℹ️',
          confirmButtonClass: 'bg-blue-600 hover:bg-blue-700 text-white',
          borderClass: 'border-blue-200',
        };
    }
  };

  const styles = getVariantStyles();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={handleCancel}
      />

      {/* Dialog */}
      <div
        className={`relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 border ${styles.borderClass}`}
      >
        {/* Header */}
        <div className="flex items-center p-4 border-b border-gray-200">
          <span className="text-2xl mr-3">{styles.icon}</span>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>

        {/* Content */}
        <div className="p-4">
          <p className="text-gray-700 whitespace-pre-wrap">{message}</p>
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3 p-4 border-t border-gray-200">
          <Button
            variant="outline"
            onClick={handleCancel}
            className="flex-shrink-0"
          >
            {cancelText}
          </Button>
          <Button
            onClick={handleConfirm}
            className={`flex-shrink-0 ${styles.confirmButtonClass}`}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
